import React from "react";
import logo from "assests/logos/small-logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LessonCompletedBadge from "Components/LessonCompletedBadge";
import ReadMoreHtml from "Components/ReadMoreHtml";
import EpisodeCard from "./EpisodeCard";

const SeriesCourse = ({
  courseData,
  isAuthenticated,
  isLoggedIn,
  isPurchased,
}) => {
  const { t } = useTranslation();
  const hasAccess = isAuthenticated || isPurchased;
  const episodes = courseData?.series || [];
  const total = episodes.length;
  const doneCount = hasAccess
    ? episodes.filter((e) => e?.is_done || e?.series_video_id?.is_done).length
    : 0;

  return (
    <div className="flex flex-col gap-10 lg:w-3/4 mx-auto py-primary">
      {/* Header */}
      <div className="flex flex-col items-center text-center">
        <h2 className="text-2xl lg:text-3xl text-white mb-4">
          {courseData?.name}
        </h2>
        {courseData?.is_done && (
          <LessonCompletedBadge variant="text" size="medium" className="mb-6" />
        )}
        <ReadMoreHtml
          html={courseData?.description}
          maxChars={200}
          className="text-lightWhite max-w-2xl"
        />

        {/* Progress + primary CTA */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 w-full max-w-xl">
          {hasAccess && total > 0 && (
            <div className="flex items-center gap-3 flex-1 w-full">
              <span className="text-sm text-lightWhite whitespace-nowrap">
                {t("courses.progress")}
              </span>
              <div className="flex-1 h-1.5 rounded-full bg-lightGrey overflow-hidden">
                <div
                  className="h-full bg-primary rounded-full transition-all"
                  style={{ width: `${(doneCount / total) * 100}%` }}
                />
              </div>
              <span className="text-sm text-lightWhite tabular-nums whitespace-nowrap">
                {doneCount} / {total}
              </span>
            </div>
          )}

          {hasAccess ? (
            <Link
              to={`/course/watch-series/${courseData?.slug}`}
              className="flex items-center justify-center gap-x-2 bg-black border border-primary hover:bg-white/5 transition-all duration-300 text-white rounded-lg px-5 py-2.5 whitespace-nowrap"
            >
              <img src={logo} alt="" className="w-6 h-6" />
              <span>{t("courses.start_watching")}</span>
            </Link>
          ) : (
            <Link
              to="/plans"
              className="flex items-center justify-center bg-darkPrimary hover:bg-primary transition-all duration-300 px-5 py-2.5 text-white rounded-lg whitespace-nowrap"
            >
              {t("courses.join_to_watch")}
            </Link>
          )}
        </div>
      </div>

      {/* Lesson grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {episodes.map((episode, index) => (
          <EpisodeCard
            key={episode?._id || index}
            episode={episode}
            index={index}
            hasAccess={hasAccess}
            slug={courseData?.slug}
          />
        ))}
      </div>
    </div>
  );
};

export default SeriesCourse;
